<app-page-header [title]="'Manufacturer Details'"
                 [subtitle]="'View details of the selected manufacturer'"></app-page-header>
<div class="mb-5">
    <h2 class="text-2xl">{{ manufacturer?.name }}</h2>
    <p><strong>ID:</strong> {{ manufacturer?.id }}</p>
    <p><strong>Email:</strong> {{ manufacturer?.mail }}</p>
    <p><strong>Address:</strong>
        {{ manufacturer?.address?.street }},
        {{ manufacturer?.address?.city }},
        {{ manufacturer?.address?.zipCode }},
        {{ manufacturer?.address?.country }}
    </p>
    <p><strong>Contract Expiration:</strong> {{ manufacturer?.contractExpirationDate | formatDate }}</p>
    <p><strong>Note:</strong> {{ manufacturer?.note }}</p>
    <p><strong>Created By:</strong> {{ manufacturer?.createdBy | roleName }}</p>
    <p><strong>Updated By:</strong> {{ manufacturer?.updatedBy | roleName }}</p>
</div>
<div class="flex justify-between gap-2">
    <div>
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isMaintainer label="Edit" text></p-button>
        <p-button (click)="confirmDelete()" icon="pi pi-trash" isMaintainer label="Delete" severity="danger"
                  text></p-button>
    </div>
    <p-button label="Back to Manufacturers" icon="pi pi-arrow-left" routerLink="/manufacturers"></p-button>
</div>

<!-- Update Dialog -->
<app-update-manufacturer-dialog
        [(visible)]="displayUpdateDialog"
        [manufacturer]="editableManufacturer"
        (manufacturerUpdated)="reloadManufacturerDetails()"
></app-update-manufacturer-dialog>
